import {useState,useEffect, useRef} from 'react'; 
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Tablescom} from '../../components/tablescomp';
import {userservices} from '../../services/userServices';
import {productservices} from '../../services/productServices';
import { exportToExcel } from '../../helpers/exporttoexcel';
import { saleServices } from "../../services/saleServices";
import {Titlebar,Searchbox,Orderstatus} from  '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate   } from "react-router";
import { Toast } from "primereact/toast";
import { TabMenu } from 'primereact/tabmenu';
const Orders = () =>{
    const toast = useRef(null);
    const navigate = useNavigate();
    const [users,setUsers] = useState([]);
    const [results,setResults] = useState([]);
    const [userloaded,setUserloaded] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const [filters, setFilters] = useState({'currentPage':'1','pageSize':'10','status':'All'});
    

    const [colDefs, setColDefs] = useState([
    { headerName: "SR NO",field: "id",width:100

     },
    { headerName: "Order Id",field: "order_id" },
    // { headerName: "SKU Code",field: "sku_code",cellRenderer: (params) => {
    //     return (
    //         <Tag severity="success" value={params.getValue()} rounded></Tag>
         
    //     );
    //   } },
    { headerName: "Sales Channel",field: "sales_channel" },
    { headerName: "Product Sold",field: "product_sold" },
    { headerName: "Date",field: "sales_date_str" },
    { headerName: "Units Sold",field: "total_units_sold" },
    { headerName: "SKU Code",field: "sku_code" },
    { headerName: "Freight Cost",field:"freight_charges"},
    { headerName: "Per Unit Sales Price",field: "sales_price" },
    { headerName: "Total Sales",field: "total_sales_price" },
    // { headerName: "Freight Charges",field: "freight_charges" },
    // { headerName: "Royalties",field: "royalties" },
    // { headerName: "Stock Reduction",field: "stock_reduction" },
    { headerName: "Order Status",field: "order_status",cellRenderer: (params) => {
          return <Orderstatus status={params.getValue()} />
      } },
    
    
    { headerName: "Action",
    cellRenderer: (params) => {
      // console.log("params");
      // console.log(params.data.id);
      return (
        <>
             <button class="btn btn-primary btn-xs btn-white " onClick={(e) => editredirect(params.data.id,params.data)}><i class="icon icon-note color-white"></i></button>&nbsp;
             <button class="btn btn-danger btn-xs btn-white btn-border-none" onClick={(e) => deletesale(params.data.id)}><i class="icon icon-trash text-white" ></i></button>&nbsp; 
             <button class="btn btn-success btn-xs btn-white btn-border-none"><i class="icon icon-eye text-white" ></i></button>  

        </>
       
      );
    } }
  ]);

  useEffect(()=>{
     getsalelist(filters.currentPage, filters.pageSize,filters.status); 
  },[])

  const editredirect = (id,saleData) =>{
    navigate(`/editsale/${id}`, { state: { sale: saleData } });
  }
  const deletesale = (id) =>{
            saleServices.deletesale(id).then((response)=>{
            if(response.status == 200){
              toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Sale deleted successfully' }); 
              getsalelist();   
            }
        }).catch((error)=>{
          
        }); 
  }


  const getsalelist  = (page, pageSize,status='All')=> {
        // setUserloaded(false);
        saleServices.getsaledata(page, pageSize,status).then((response)=>{
            if(response.status == 200){
                setResults(response.data.data.data);
                setUserloaded(false);
                 setTotalRows(response.data.data.total);
                setCurrentPage(response.data.data.current_page);
            }else{
              setResults([]);
                // setUsers([]);
                 setUserloaded(false);
            }  
        }).catch((error)=>{
          setResults([]);
            // setUsers([]);
            // setUserloaded(true);
        }); 
  } 

  const addproductnavigate = () =>{
    // navigate.  
    navigate('/addsale');
  }
  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
      setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:currentPage + 1
         } 
      });
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:currentPage - 1
         } 
      });
    }
  };
  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
      setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:newPage
         } 
      });
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    // getsalelist( 1, newSize);
    setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:1
         } 
    });
    
  };
    const items = [
   
    {
      label: 'All Orders',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('All'),
    },
    {
      label: 'Open',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Open'),
    },
    {
      label: 'Confirmed',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Confirmed'),
    },
    {
      label: 'Packed',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Packed'),
    },
    {
      label: 'Shipped',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Shipped'),
    },
    {
      label: 'Delivered',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Delivered'),
    },
    {
      label: 'Closed',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Closed'),
    },

    {
      label: 'Cancelled',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Cancelled'),
    },
    {
      label: 'Returned',
      icon: 'fa fa-angle-right',
      command: () => handleStockFilter('Returned'),
    }
  ];
  function handleStockFilter(status) {
     setFilters((prevData)=>{
         return {
            ...prevData,
            currentPage:1,
            status:status
         } 
      });   
    // getsalelist(1,pageSize,status);
  }

  useEffect(()=>{
       getsalelist(filters.currentPage, filters.pageSize,filters.status);       
    },[filters])

  const handleExport = () => {
     exportToExcel({ data: results, filename: 'stock' });
  }

  return(
       <>
        <Toast ref={toast} />
          {/* <Bredcrum title={'Orders'} divider={false}/> */}
          <div class="row">
            
              <div className='col-md-12 mb-2 mt-2'>
                 <div className='flex-box flex-between'>
                      {/* <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => addproductnavigate()}>Add New Sales</button>  */}
                      <div></div>
                     <Searchbox value={quickFilterText} onChange={(e) => setQuickFilterText(e.target.value)} />
                  </div> 
              </div> 
             
              
              {/* <Titlebar text={'Sales Overview'}/> */}
              <div className="col-md-12 mt-3">
                <div className='row'>
                      <div className='col-md-9'>
                        <TabMenu model={items} activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} />
                    </div> 
                     <div className='col-md-3'>
                        <div>
                          <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                            <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
                        </div>
                      </div>
                </div>
               
                  <div className='card'>
                    <div className='card-body card-body-style'>
                     <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded}  quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange}/>
                     </div>
                 </div>
              </div>   
          </div>
       </>
    );   
 }
 export default Orders;